import { z } from 'zod';
const text = z.string().nullish();
export function pagedSchema<T extends z.ZodType>(item: T) {
  return z.looseObject({
    data: z.array(item),
    page: z.number(),
    totalItems: z.number(),
    totalPages: z.number(),
    paginationToken: text,
  });
}
export function wire<S extends z.ZodType>(schema: S, data: unknown, label: string): z.output<S> {
  const parsed = schema.safeParse(data);
  if (parsed.success) return parsed.data;
  if (!import.meta.env.PROD) console.warn(`${label} fora do contrato`, parsed.error.issues);
  return data as z.output<S>;
}
export const withSignal = (signal?: AbortSignal) => (signal ? { signal } : {});
